export default __webpack_public_path__ + "static/media/rettich-screen1.92e8c2b0.png";